// Utility functions for formatting data

export const formatVND = (value: number | string | undefined) => {
  const num = typeof value === 'string' ? Number(value) : value;
  if (typeof num !== 'number' || isNaN(num)) return '—';
  
  // Làm tròn số và format thủ công để đảm bảo dấu phẩy và không có .00
  const roundedNum = Math.round(num);
  const formatted = roundedNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return formatted + ' VNĐ';
};

export const formatDate = (dateStr: string | undefined) => {
  if (!dateStr) return '—';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '—';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

// Map trạng thái sang tiếng Việt
export const mapStatusToVN = (status: string) => {
  switch (status) {
    case 'pending_deployment': return 'Chờ triển khai';
    case 'in_use': return 'Đang sử dụng';
    case 'in_storage': return 'Lưu kho';
    case 'under_maintenance': return 'Bảo dưỡng/Sửa chữa';
    case 'disposed': return 'Đã thanh lý';
    default: return status;
  }
};

// Map trạng thái phê duyệt sang tiếng Việt
export const mapApprovalStatusToVN = (status: string) => {
  switch (status) {
    case 'pending': return 'Chờ duyệt';
    case 'approved': return 'Đã duyệt';
    case 'rejected_editable': return 'Từ chối (có thể sửa)';
    case 'rejected_final': return 'Từ chối (cuối cùng)';
    default: return status;
  }
};

// Map tình trạng kỹ thuật sang tiếng Việt
export const mapTechnicalConditionToVN = (condition: string) => {
  switch (condition) {
    case 'new': return 'Mới';
    case 'good': return 'Tốt';
    case 'average': return 'Trung bình';
    case 'bad': return 'Kém';
    case 'broken': return 'Hỏng';
    default: return condition || '—';
  }
}; 